import { defineFieldTypeTemplate } from '#layers/data-model/field-types/define';

export default defineFieldTypeTemplate({
	type: 'primitive',
	id: 'boolean',
	name: '$t:field_types.boolean.name',
	description: '$t:field_types.boolean.description',
	icon: 'lucide:toggle-left',
	sort: 300,
	keywords: ['toggle', 'switch', 'true', 'false', 'checkbox'],
	supportedPrimitiveTypes: ['boolean'],
});
